import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { useLocalStorage } from "react-use";
import { ISubscription } from "../../../models/ISubscriptionDetails";
import { useRecoilState } from "recoil";
import { subscriptionState } from "../../../../hooks/atoms/subscriptions";


interface IUpgradePlan {
    onUpgrade: () => void;
}

const UpgradePlan: React.FC<IUpgradePlan> = ({ onUpgrade }) => {

    // const [subscription,] = useLocalStorage<ISubscription>('subscription')
    const [subscription, setSubscriptionDetails] = useRecoilState(subscriptionState)

    const handleClick = () => {
        onUpgrade()
    }

    return (
        <div style={{ padding: 10 }}>
            <p><b>Seu limite é de {subscription?.subscription?.subscription_limit} disciplinas.</b></p>
            <p>Para utilizar mais, adquira um novo plano.</p>
            <button type='button' onClick={() => handleClick()} style={{
                display: 'flex', alignItems: 'center', gap: 9, color: 'white',
                backgroundColor: 'transparent', border: '1px solid white', fontSize: 14, padding: 8, borderRadius: 5
            }}  >
                <RiMoneyDollarCircleLine size={20} />
                <span>Ver planos</span>
            </button>
        </div>
    )
}


export default UpgradePlan;